module.exports = "data:image/webp;base64,UklGRqQAAABXRUJQVlA4IJgAAACwBACdASoZABkAPpFIn0olpKMhqAqosBIJZQC7ADHHFTIIpFswlG7tWpf29zkAAP7neGT7dAvFFmEl7aN2Sf0bw1Z0vRuX+51z9iaXHiDS408LmmTQrYUnwgULkHol4sUT4DAiHozTK9cmZFkgJljx/vxaVhgzHB/xYpKHpFdn4CxlYlUXEExk07iKz8jMe5Yj029CtUAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/brown_white.webp
// module id = vZJ+
// module chunks = 14